<script lang="ts" setup>
import MediaList from '@/components/media/MediaList.vue';
import QuizAnswersField from '@/components/quiz/QuizAnswersField.vue';
import { QuizQuestion } from '@/models/quiz-question.model';
import { ref, PropType, watch } from 'vue';

const props = defineProps({
  modelValue: { type: Object as PropType<QuizQuestion>, required: true },
});
const value = ref<QuizQuestion>({ ...props.modelValue });

const emit = defineEmits(['update:modelValue']);

const update = () => {
  emit('update:modelValue', value.value);
};

watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);
</script>
<template>
  <v-row>
    <v-col>
      <v-text-field
        v-model="value.title"
        @change="update"
        label="Title"
        required
      ></v-text-field>

      <QuizAnswersField v-model="value.answers" @change="update" />

      <MediaList v-model="value" @change="update" />
    </v-col>
  </v-row>
</template>
